// Caps how many extras a customer can tick for one product.
//
// Wrap the extra checkboxes in an element with data-max-extras="3": once that
// many are checked, the remaining ones are disabled until one is unticked.
// The server enforces the same limit (Storefront::OrdersController#add_to_cart).

const enforce = (group) => {
  const max = parseInt(group.dataset.maxExtras, 10)
  if (!max) return

  const boxes = group.querySelectorAll('input[type="checkbox"]')
  const checked = Array.from(boxes).filter((box) => box.checked).length

  boxes.forEach((box) => {
    const blocked = !box.checked && checked >= max
    box.disabled = blocked
    const row = box.closest("label, [data-extra-row]")
    if (row) row.classList.toggle("opacity-50", blocked)
    if (row) row.classList.toggle("cursor-not-allowed", blocked)
  })
}

const enforceAll = (root = document) => {
  root.querySelectorAll("[data-max-extras]").forEach(enforce)
}

document.addEventListener("change", (event) => {
  const group = event.target.closest && event.target.closest("[data-max-extras]")
  if (group) enforce(group)
})

// form.reset() restores the default ticks without firing "change"
document.addEventListener("reset", (event) => {
  setTimeout(() => enforceAll(event.target), 0)
})

document.addEventListener("turbolinks:load", () => enforceAll())
document.addEventListener("DOMContentLoaded", () => enforceAll())
